import { CustomerStory } from "@/content/customerStories/customerStories.types";

export type FilterCategories =
    | "solution"
    | "product"
    | "industry"
    | "more filters";

export type FilterOptions = {
    committedActive: boolean;
    stagedActive: boolean;
    description?: string;
    grouping?: "region" | "team size";
};

export type SubFilterObject = {
    [filter: string]: FilterOptions;
};

export type CustomerStoryFilterObject = {
    [key in FilterCategories]: SubFilterObject;
};

export interface CustomerStoriesSectionProps {
    totalNumberOfCustomerStories: number;
    customerStoryList: CustomerStory[];
    fallbackCustomerStoryList: CustomerStory[];
    filterSearchHasRun: boolean;
    loadMoreStories: () => void;
}

export interface StoryGridItem {
    stories: CustomerStory[];
    height: number;
}

export interface StoryGrid {
    [key: number]: StoryGridItem;
}

export type cardType = "sm" | "md" | "lg";

export interface CustomerStoriesGridProps {
    storiesGrid: StoryGrid;
    numColumns: 1 | 2 | 3;
}

export interface ParsedCustomerStories {
    customerStories: CustomerStory[];
    filters: CustomerStoryFilters;
}

export interface CustomerStoryFilters {
    products: ContentFacetContext[];
    industries: ContentFacetContext[];
    regions: ContentFacetContext[];
    teamSizes: ContentFacetContext[];
    solutions: ContentFacetContext[];
}

export interface ContentFacetContext {
    name: string;
    id: string;
}
